module.exports = __webpack_public_path__ + "img/right-arr.42ac369f.svg";